import { onAuthStateChanged, Unsubscribe } from "firebase/auth";
import { getDatabase, onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getShowsBySearch, ShowType } from "../api";
import Navbar from "../components/Navbar";
import {
  auth,
  deleteFavouriteShow,
  deleteWatchingShow,
  writeFavouriteShow,
  writeWatchingShow,
} from "../firebase";
import { setPreviousSearch } from "../redux/SearchSlice";
import { store } from "../redux/store";

const Home = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(auth.currentUser);
  const [currentSearch, setcurrentSearch] = useState("");
  const [shows, setShows] = useState([] as ShowType[]);
  const [favourites, setFavourites] = useState([] as ShowType[]);
  const [watching, setWatching] = useState({} as ShowType);

  const previousSearch = useSelector((state: any) => state.search.value);

  useEffect(() => {
    let favouritesUnsubscribe: Unsubscribe | undefined = undefined;
    let watchingUnsubscribe: Unsubscribe | undefined = undefined;

    onAuthStateChanged(auth, async (user) => {
      if (!user) navigate("/login");
      else {
        setCurrentUser(user);
        const db = getDatabase();
        const dbFavourites = ref(db, "users/" + auth.currentUser?.uid + "/favourites/");
        favouritesUnsubscribe = onValue(dbFavourites, (snapshot) => {
          const data = snapshot.val();
          if (data) setFavourites(Object.values(data));
          else setFavourites([]);
        });

        const dbWatching = ref(db, "watching/" + auth.currentUser?.uid);
        watchingUnsubscribe = onValue(dbWatching, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            setWatching(data);
          } else setWatching({} as ShowType);
        });
        const shows: ShowType[] = await getShowsBySearch(previousSearch);
        setShows(shows);
      }
    });

    return () => {
      if (favouritesUnsubscribe && watchingUnsubscribe) {
        favouritesUnsubscribe();
        watchingUnsubscribe();
      }
    };
  }, []);

  const handleSearchChange = (e: any) => {
    const currentSearch = e.target.value;
    setcurrentSearch(currentSearch);
  };

  return (
    <>
      <Navbar page={"home"} />
      <h1 className="text-3xl text-center font-bold dark:text-slate-300 m-6">
        Welcome {currentUser?.displayName}
      </h1>
      {Object.keys(watching).length !== 0 ? (
        <div className="m-5 flex items-center gap-3 ">
          <div
            className="bg-cover rounded-full"
            style={{
              backgroundImage: `url(${watching.image})`,
              minWidth: "6rem",
              minHeight: "6rem",
            }}
          ></div>
          <div className="space-y-0.5 overflow-hidden">
            <p className="truncate text-lg text-black dark:text-slate-300 font-semibold">
              {watching.title}
            </p>
            <p className="truncate text-slate-500 dark:text-slate-600 font-medium">
              {watching.genres}
            </p>
          </div>
          <button
            className="ml-auto dark:text-slate-200"
            onClick={() => {
              deleteWatchingShow();
            }}
          >
            {/* prettier-ignore */}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7"> <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" /> </svg>
          </button>
        </div>
      ) : null}
      <form
        className="flex align-center justify-center dark:text-slate-300 m-8"
        onSubmit={async (e: any) => {
          e.preventDefault();
          if (currentSearch !== "") {
            const shows: ShowType[] = await getShowsBySearch(currentSearch);
            setShows(shows);
            setcurrentSearch("");
          }
          store.dispatch(setPreviousSearch(e.target[0].value));
        }}
      >
        <input
          type="text"
          placeholder="Search"
          onChange={handleSearchChange}
          value={currentSearch}
          className="p-2 w-36 placeholder:italic placeholder:font-semibold dark:placeholder:text-slate-500 focus:outline-none bg-transparent border-y-2 border-l-2 border-blue-600 rounded-l-lg"
        />
        <button type="submit" className="py-2 px-3 bg-blue-600 text-white rounded-r-lg">
          {/* prettier-ignore */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>
        </button>
      </form>
      <div className="flex flex-wrap gap-8 justify-center mb-8">
        {shows.map((show) => (
          <div
            key={show.id}
            className="flex flex-col w-64 overflow-hidden text-black dark:text-slate-200 rounded-[12px] shadow-2xl dark:bg-slate-800"
          >
            <img src={show.image} alt={show.title} className="rounded-t-lg" />
            <div className="py-4 px-5 space-y-3">
              <h2 className="text-xl text-left truncate font-semibold">{show.title}</h2>
              <div className="flex justify-between">
                <button
                  onClick={() => {
                    navigate("/detail/" + show.id);
                  }}
                  className="py-1.5 px-3.5 bg-blue-600 text-white font-medium rounded-lg"
                >
                  Info
                </button>
                <div className="flex items-center gap-3">
                  <button
                    className="disabled:opacity-20"
                    onClick={() => {
                      if (Object.keys(watching).length === 0)
                        writeWatchingShow(show.id, show.title, show.genres, show.image);
                      else deleteWatchingShow();
                    }}
                    disabled={
                      Object.keys(watching).length > 0
                        ? watching.id !== show.id
                          ? true
                          : false
                        : false
                    }
                  >
                    {/* prettier-ignore */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"> <path strokeLinecap="round" strokeLinejoin="round" d={watching.id === show.id ? "M15.75 5.25v13.5m-7.5-13.5v13.5" : "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"} /> </svg>
                  </button>
                  <button
                    onClick={() => {
                      if (favourites.find((favourite) => favourite.id === show.id)) {
                        deleteFavouriteShow(show.id);
                      } else {
                        writeFavouriteShow(show.id, show.title, show.genres, show.image);
                      }
                    }}
                  >
                    {/* prettier-ignore */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" 
                      className={`w-6 h-6 ${favourites.find((favourite) => favourite.id === show.id) ? 'fill-red-600 stroke-red-600' : ''}`}> <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" /> </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Home;
